<template>
  <form-field-date-picker
    label="Date"
    v-model="form.deal_at"
    :validation-errors="validationErrors.deal_at"
    is-inline
  ></form-field-date-picker>
</template>

<script>
import {FormMixin} from "./forms.mixin";

export default {
  name: "LeadDealForm",
  props: ['formData'],
  mixins: [FormMixin],
  data() {
    return {
      form: {},
      validationErrors: {},
      defaultForm: {
        deal_at: new Date(),
      },
    }
  },
  created() {
    this.form = (this.formData && this.formData.id) ? this.$utils.clone({...this.defaultForm, ...this.formData}) : this.$utils.clone(this.formData);
  },
  methods: {
    update() {
      return this.$api.records.markAsDeal(this.form.id, this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Deal At Date was updated',
            type: 'is-success'
          });

          return res;
        });
    },
  }
}
</script>

<style scoped>

</style>
